import React from 'react';
/**
 * Simplified circular pulse animation component for Webflow
 * Standalone version without curve-home dependency
 */
export class RecordingAnimation extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "recording-animation-wrapper top-0 h-100 w-100 absolute" },
            React.createElement("div", { id: "recording-pulse", style: {
                    width: '150px',
                    height: '150px',
                    margin: '0 auto',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(247, 50, 104, 0.8) 0%, rgba(247, 50, 104, 0.4) 50%, transparent 70%)',
                    animation: 'pulse 2s ease-in-out infinite',
                } }),
            React.createElement("style", null, `
                    @keyframes pulse {
                        0%, 100% {
                            transform: scale(1);
                            opacity: 1;
                        }
                        50% {
                            transform: scale(1.1);
                            opacity: 0.7;
                        }
                    }
                `)));
    }
}
